export const actions = {
  SET_GLOBAL_STATUS: 'SET_GLOBAL_STATUS',
  SET_COACHES_ARRAY: 'SET_COACHES_ARRAY',
  SET_LOCAL_INFO: 'SET_LOCAL_INFO',
  SET_ASYNC_GLOBAL: 'SET_ASYNC_GLOBAL',
  SET_ASYNC_LOCAL: 'SET_ASYNC_LOCAL',
  SET_ASYNC_COACHES: 'SET_ASYNC_COACHES',
  SET_ASYNC_SYNC: 'SET_ASYNC_SYNC',
  SET_SYNC: 'SET_SYNC',
  SET_TOKEN: 'SET_TOKEN',
  CLEAR_TOKEN: 'CLEAR_TOKEN',
  ASYNC_CHANGE_LOGIN_FORM: 'ASYNC_CHANGE_LOGIN_FORM',
  CHANGE_LOGIN_FORM: 'CHANGE_LOGIN_FORM',
  ASYNC_LOGIN: 'ASYNC_LOGIN',
  TOOGLE_DISABLE: 'TOOGLE_DISABLE',
  TOOGLE_REQUESTING: 'TOOGLE_REQUESTING',
  RESET_FORMS: 'RESET_FORMS',
  CHECK_IF_ENTER: 'CHECK_IF_ENTER',
  SET_IS_ADMIN: 'SET_IS_ADMIN',
  SET_IN_REQUEST: 'SET_IN_REQUEST',
  SET_MODAL_BUTTON: 'SET_MODAL_BUTTON',
  ASYNC_CREDENTIAL_VALUE: 'ASYNC_CREDENTIAL_VALUE',
  SET_CREDENTIALS_VALUE: 'SET_CREDENTIALS_VALUE',
  ASYNC_CANCEL_CREDENTIALS: 'ASYNC_CANCEL_CREDENTIALS',
  ADMIN_SEND_CREDENTIALS: 'ADMIN_SEND_CREDENTIALS',
  ASYNC_ADD_COACH: 'ASYNC_ADD_COACH',
  ADD_COACH: 'ADD_COACH',
  ASYNC_COACH_FORM_VALUE: 'ASYNC_COACH_FORM_VALUE',
  SET_COACH_FORM_VALUE: 'SET_COACH_FORM_VALUE',
  SET_COACH_FORM_VALUE_COMPLETE: 'SET_COACH_FORM_VALUE_COMPLETE',
  CLEAR_COACH_FORM_VALUE: 'CLEAR_COACH_FORM_VALUE',
  SET_SEARCH_VALUE: 'SET_SEARCH_VALUE',
  SET_ADMIN_SEARCH_VALUE: 'SET_ADMIN_SEARCH_VALUE',

  ASYNC_GET_USERS: "ASYNC_GET_USERS",
  ASYNC_REMOVE_USER: "ASYNC_REMOVE_USER",
  REMOVE_USER: "REMOVE_USER",

  ASYNC_GO_TO_EDIT_USER: "ASYNC_GO_TO_EDIT_USER",
  ASYNC_GET_USER_BY_ID: "ASYNC_GET_USER_BY_ID",
  SET_LOADING_USER: "SET_LOADING_USER",
  ASYNC_EDIT_USER: "ASYNC_EDIT_USER",
  ASYNC_GO_TO_ADD_USER: "ASYNC_GO_TO_ADD_USER",
  CHANGE_USER_LOGGED: "CHANGE_USER_LOGGED",
  ASYNC_GET_USER_LOGGED: "ASYNC_GET_USER_LOGGED",
  CHANGE_USER_LOGGED_LOADING: "CHANGE_USER_LOGGED_LOADING",

  FETCH_RANK_START:"FETCH_RANK_START",
  FETCH_RANK_FINISH:"FETCH_RANK_FINISH",
  FETCH_RANK_FAILURE:"FETCH_RANK_FAILURE"

}

export const basepath = `${process.env.REACT_APP_API_V2_BASE_URL}/v2/unidades`;

export const endpoints = {
  global: `${basepath}/stats/global`,
  local: `${basepath}/stats/local`,
  coaches: `${basepath}/coaches/info`,
  token: `${basepath}/token`,
  login: `${basepath}/auth/token`,
  userCreate: `${basepath}/users/create`,
  userEdit: `${basepath}/users/edit`,
  listUsers: `${basepath}/users/list`,
  userInfo: `${basepath}/users/info`,
  removeUser: `${basepath}/users/remove`,
  rank: `${basepath}/stats/rank`,
}
export const STATUS = {
  0: 'Inativo',
  1: 'Ativo',
  2: 'Expirando',
  3: 'Expirado',
  4: 'Recorrente periodo extra',
  5: 'Recorrente expirado',
  200: 'Pronto',
  201: 'Sem licença',
  202: 'Experimental',
}




// WEBPACK FOOTER //
// ./src/utils/constants.js